import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXamlComponent } from './simple-icons-xaml.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXamlComponent ],
    exports:      [ SimpleIconsXamlComponent ],
    bootstrap:    []
})
export class SimpleIconsXamlModule {}
